<div class="dialog-content-wrapper">
  <form [formGroup]="editForm" class="k-form-inline">

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="question">Question</label>
      <div class="col-8">
        <textarea class="form-control" id="question" formControlName="question" rows="4" style="width:100%;"
          appAutoFocus></textarea>
        <div *ngIf="question?.invalid" class="alert alert-danger">
          <div *ngIf="question?.errors?.['required']">Question is required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label">Response Type</label>
      <div class="col-8">

        <kendo-formfield showHints="initial">
          <ul class="horizontal-radio-list">
            @for(item of responseTypes; track item){
            <li class="k-radio-item">
              <kendo-label for="opt{{item}}" text={{item}}></kendo-label>
              <input type="radio" value={{item}} id="opt{{item}}" formControlName="response_type"
                (change)="onRadioChange()" kendoRadioButton />
            </li>
            }
            @empty {
            <li>No options found.</li>
            }
          </ul>
        </kendo-formfield>
      </div>
    </div>
    <!--    {{JSON.stringify(rawData)}}-->
    <div class="k-form-field" *ngIf="response_type?.value === 'Select One' || response_type?.value === 'Select Many'">
      <label class="form-label col-3 k-label" for="decimal_places">Options</label>
      <div class="col-8">
        <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
          [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
          style=" max-height: 400px;" [pageSize]="pageSize" [pageable]="true">

          <ng-template kendoGridToolbarTemplate position="top">
            <button (click)="onAddClick()" kendoButton class="btn btn-primary" style="padding: 4px 8px">
              <fa-icon icon="circle-plus" style="font-size:small"></fa-icon> Add Option </button>
          </ng-template>

          <kendo-grid-column title="Edit" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button (click)="onEditClick(dataItem)" kendoButton class="btn btn-stn-grid" style="padding: 4px 8px">
                <fa-icon icon="edit" style="font-size:small"></fa-icon>
              </button>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column title="Sort Order" [width]="90">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <!--              {{dataItem.sort_order}}-->
              <button (click)="onUpClick(dataItem)" kendoButton class="btn btn-stn-grid" *ngIf="rowIndex != 0"
                style="padding: 4px 8px; margin-right: 2px">
                <fa-icon icon="arrow-up" style="font-size:small"></fa-icon>
              </button>
              <button (click)="onDownClick(dataItem)" kendoButton class="btn btn-stn-grid"
                *ngIf="rowIndex != gridData.length - 1 " style="padding: 4px 8px">
                <fa-icon icon="arrow-down" style="font-size:small"></fa-icon>
              </button>

            </ng-template>
          </kendo-grid-column>


          <kendo-grid-column field="option" title="Description" [width]="250" [sortable]="false">
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
              let-filterService="filterService">
              <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column title="Delete" [width]="80">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid" style="padding: 4px 8px">
                <fa-icon icon="trash" style="font-size:small"></fa-icon>
              </button>
            </ng-template>
          </kendo-grid-column>

          <ng-template kendoPagerTemplate>
            <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
          </ng-template>

        </kendo-grid>
      </div>
    </div>

    <div class="k-form-field" *ngIf="response_type?.value === 'Numeric'">
      <label class="form-label col-3 k-label" for="decimal_places">Decimal Places</label>
      <div class="col-8">
        <input type="number" id="decimal_places" formControlName="decimal_places" class="form-control" min="0" step="1"
          appIntegerOnly>
        <div *ngIf="decimal_places?.invalid" class="alert alert-danger">
          <div *ngIf="decimal_places?.errors?.['required']">Decimal Places are required.</div>

        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="compulsory">Compulsory</label>
      <div class="col-8">
        <kendo-checkbox id="compulsory" formControlName="compulsory" size="large"></kendo-checkbox>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="supervisor_applicable">Supervisor Applicable</label>
      <div class="col-8">
        <kendo-checkbox id="supervisor_applicable" formControlName="supervisor_applicable"
          size="large"></kendo-checkbox>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="supervisee_applicable">Supervisee Applicable</label>
      <div class="col-8">
        <kendo-checkbox id="supervisee_applicable" formControlName="supervisee_applicable"
          size="large"></kendo-checkbox>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="professional_applicable">Professional Applicable</label>
      <div class="col-8">
        <kendo-checkbox id="professional_applicable" formControlName="professional_applicable"
          size="large"></kendo-checkbox>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="help_info_id">Help Information</label>
      <div class="col-8">
        <kendo-dropdownlist id="help_info_id" formControlName="help_info_id" [data]="helpInfoList"
          [valuePrimitive]="true" textField="element_name" valueField="id"
          [defaultItem]="{ id: null, element_name: 'Select...' }">
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div>
              <strong>{{ dataItem.site_section }} - {{ dataItem.element_name }}</strong><br>
              {{ dataItem.heading }}<br>
              <p [innerHTML]="dataItem.html"></p>
            </div>
          </ng-template>

          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div *ngIf="dataItem">
              <strong>{{ dataItem.site_section }} - {{ dataItem.element_name }}</strong><br>
              {{ dataItem.heading }}<br>
              <p [innerHTML]="getTruncatedHtml(dataItem.html)"></p>
            </div>
            <span *ngIf="!dataItem">Select...</span>
          </ng-template>
        </kendo-dropdownlist>
      </div>
    </div>


  </form>
</div>


<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
